import {Pipe, PipeTransform}                 from '@angular/core';
import {Helper}                 from "../utils/helper";
import {FormuleEnum}            from "@shared/enums/formule.enum";
import {PriceFormuleParameters} from "../../components/main/oav-phase-b/preconisation/priceFormuleParameters";

@Pipe({standalone:true,name: 'PricePrecoPipe'})
export class PricePrecoPipe implements PipeTransform {
    transform(prices: PriceFormuleParameters[], formuleEnum: FormuleEnum): string {
        const p = prices.find(f => f.formuleEnum === formuleEnum);
        if (p) {
            return `${Helper.currencyFormatter(p.price.GLOBAL || 0, 'EUR', '1.2-2')}`;
        }
        return '';
    }
}
